module.exports = __webpack_public_path__ + "img/111.b705e659.jpg";